<template>
  <ul class="candidates">
    <li
      v-for="candidate in sortedCandidates"
      :key="candidate.recipient_id"
      :class="['candidate', candidate.status]"
    >
      <vs-text class="candidate__name">{{ candidate.recipient_name }}</vs-text>
    </li>
  </ul>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'
import { Availability } from '@/api/pools'
import { sortBy } from 'lodash'

export default defineComponent({
  name: 'PoolStageAvailability',

  props: {
    candidates: {
      type: Array as PropType<Availability[]>,
    },
  },

  setup(props) {
    const sortedCandidates = computed<Availability[]>(() => {
      return sortBy(props.candidates, ['recipient_name', (c) => c.status === 'NotAvailable'])
    })

    return {
      sortedCandidates,
    }
  },
})
</script>

<style scoped>
.candidate.NotAvailable {
  text-decoration: line-through;
  opacity: 0.6;
}

.candidates {
  display: inline;
  list-style: none;
  padding: 0;
}

.candidate {
  display: inline;
}

.candidate:not(:last-child)::after {
  content: ', ';
}

.candidate__name {
  display: inline;
  white-space: pre;
}
</style>
